import { useState } from 'react'
import { SmithyPanel } from './SmithyPanel'
import { ArmoryWeaponsPanel } from './ArmoryWeaponsPanel'
import type { WalletInfo } from '@/economy/types'
import type { InteractionTarget } from '@/state/useEconomyStore'

interface PanelProps { interaction: InteractionTarget; wallet: WalletInfo | null }

export function ArmoryPanel(props: PanelProps) {
  const [tab, setTab] = useState<'weapons' | 'crafting'>('weapons')

  return (
    <>
      <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
        <button
          className={`panel-btn ${tab === 'weapons' ? 'panel-btn--primary' : ''}`}
          onClick={() => setTab('weapons')}
        >
          Weapons
        </button>
        <button
          className={`panel-btn ${tab === 'crafting' ? 'panel-btn--primary' : ''}`}
          onClick={() => setTab('crafting')}
        >
          Crafting
        </button>
      </div>

      {tab === 'weapons' ? (
        <ArmoryWeaponsPanel {...props} />
      ) : (
        <SmithyPanel {...props} />
      )}
    </>
  )
}
